export const CALIBRATION_COLOR_COUNT = 5;

export function calibrationColorVar(bucketIndex: number): string {
  return `--color-apple-calibration-map-${bucketIndex}`;
}
